export const iconFontAwesomeHolidaysGifts = (
	<i className="fa-solid fa-gifts"></i>
);
